import { Skeleton } from '@/_components/ui/skeleton'
import type { WithAuthComponentProps } from '@/_hocs/with-auth'
import { WithAuth } from '@/_hocs/with-auth'
import { FiltersBar } from '@/features/_components/filters-bar'
import { InlineSearchbox } from '@/features/_components/inline-searchbox'
import { Container } from '@/features/_components/ui/container'
import { PageLayout } from '@/features/_components/ui/page-layout'
import { useCompanyContext } from '@/features/_contexts/company-context'
import { useSearch } from '@tanstack/react-router'
import { CreateFacilityButton } from '../../_components/create-facility-button'
import { CompanyHeader } from '../_components/company-header'
import { CompanyHeaderLoading } from '../_components/company-header-loading'
import { FacilitiesTable } from '../_components/facilities-table'
import { FacilitiesTableSkeleton } from '../_components/facilities-table-skeleton'

const Facilities = ({ session }: WithAuthComponentProps) => {
  const company = useCompanyContext()
  const isStaff = session.user.userType === 'staff'
  const searchParams = useSearch({ strict: false }) as { search?: string }
  const search = searchParams?.search

  if (!company) {
    if (!isStaff) {
      return (
        <PageLayout
          title="Unidades"
          filters={
            <FiltersBar>
              <InlineSearchbox search="" placeholder="Busque por alguma unidade" disabled />
            </FiltersBar>
          }
        >
          <FacilitiesTableSkeleton />
        </PageLayout>
      )
    }

    return (
      <Container className="px-14 py-10 gap-6">
        <CompanyHeaderLoading showBack />

        <FiltersBar>
          <InlineSearchbox search="" placeholder="Busque por alguma unidade" disabled />
          <Skeleton className="h-8 w-[120px] rounded-md" />
        </FiltersBar>

        <FacilitiesTableSkeleton />
      </Container>
    )
  }

  if (!isStaff) {
    return (
      <PageLayout
        title="Unidades"
        filters={
          <FiltersBar>
            <InlineSearchbox search={search ?? ''} placeholder="Busque por alguma unidade" />
          </FiltersBar>
        }
      >
        <FacilitiesTable companyId={company.id} search={search} />
      </PageLayout>
    )
  }

  return (
    <Container className="px-14 py-10 gap-6">
      <CompanyHeader
        company={company}
        backHref="/companies"
        breadcrumbs={[{ label: 'Empresas', href: '/companies' }, { label: company.name }]}
        tabs={{ showPersons: true, showUsers: true, showSettings: true }}
      />

      <FiltersBar>
        <InlineSearchbox search={search ?? ''} placeholder="Busque por alguma unidade" />
        <CreateFacilityButton companyId={company.id} />
      </FiltersBar>

      <FacilitiesTable companyId={company.id} search={search} />
    </Container>
  )
}

export default WithAuth(Facilities, { allowedFor: ['staff', 'tenant'] })
